import React from "react";
const SvgStarSlim = props => (
  <svg viewBox="0 0 18 18" {...props}>
    <path
      fill="none"
      stroke="#FFF"
      strokeLinejoin="round"
      strokeWidth={0.8}
      d="M12 6.5h4.4c.4 0 .7.5.4.8l-3.4 3.2c-.1.2-.3.2-.2.4l1.4 5.9c0 .3-.2.4-.4.3L9 13.6l-5.3 3.5c-.2 0-.4 0-.4-.3l1.4-5.9-.2-.4L1 7.3c-.2-.2 0-.8.4-.8h4.4c.3 0 .5-.1.7-.5l2.1-4.8c.1-.2.4-.3.5 0L11.3 6c.2.3.4.5.7.5z"
    />
  </svg>
);
export default SvgStarSlim;
